import {ResourceChangeset} from "core-app/modules/fields/changeset/resource-changeset";
import {GridWidgetResource} from "core-app/modules/hal/resources/grid-widget-resource";

export class WidgetChangeset extends ResourceChangeset<GridWidgetResource> {

}
